class SendAHint extends HTMLElement {


    // re-run when element is added to DOM or when observed attributes change
    connectedCallback() {
        const rootElement = this;

        // get variant id
        const variantID = rootElement.getAttribute("data-variant-id");

        // if no variant exit
        if (!variantID) {
            rootElement.innerHTML = "";
            return;
        }

        const product = JSON.parse(rootElement.getAttribute("data-product"));

        // find the variant
        const variant = product.variants.find(v => v.id == variantID);
        if (!variant) {
            return;
        }

        let recipientName = '';
        let senderName = '';

        // if there's only default variant, set variantTitle to empty
        let variantTitle = '';
        if (product.variants.length > 1) {
            variantTitle = variant.title;
        }
        let image = product.images[0];


        rootElement.innerHTML = `
             <div class="sendHint">
                    <button class="sendHintBtn button openHint">SEND A HINT</button>
                    <dialog class="sendHintModal">
                        <div class="sendHintModalBody">
                            <button class="sendHintModalClose">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14 12.6201L1.37988 0L0 1.37988L12.6201 14L14 12.6201Z"
                                          fill="#4F4F4F"></path>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.37988 14L14 1.37988L12.6201 0L0 12.6201L1.37988 14Z"
                                          fill="#4F4F4F"></path>
                                </svg>
                            </button>
                            <div class="sendHintModalContent">
                                <p class="sendHintModalContentTxt">Dear <span class="recipientName">[RECIPIENT NAME]</span>,</p>
                                <p class="sendHintModalContentTxt"><span class="senderName">[YOUR NAME]</span> has a wish - and it's our ${product.title}. Here's a little note they wanted to share with you:</p>
                                <p class="sendHintModalContentTxt"><span class="note"></span></p>
                                <img class="sendHintModalContentImg" src="${image}&width=500" alt="${product.title}">
                            </div>
                            <form class="sendHintModalForm active">
                                <input class="sendHintModalFormInput" name="recipient_name" type="text" aria-label="Recipient Name" placeholder="Recipient Name" required>
                                <input class="sendHintModalFormInput" name="recipient_email" type="email" aria-label="Recipient Email" placeholder="Recipient Email" required>
                                <div class="sendHintModalFormBreak"></div>
                                <input class="sendHintModalFormInput" name="sender_name" type="text" aria-label="Your Name" placeholder="Your Name" required>
                                <input class="sendHintModalFormInput" name="sender_email" type="email" aria-label="Your Email" placeholder="Your Email" required>
                                <textarea class="sendHintModalFormInput note" name="note" rows="3" aria-label="Note" placeholder="A note is required to send your hint" required></textarea>
                                <button class="sendHintModalFormSubmit button">SEND</button>
                                <span class="sendHintModalFormError"></span>
                            </form>
                             <div class="sendHintModalSuccess">We've sent your hint!</div>
                        </div>
                    </dialog>
                </div>
        `;

        // update form values on input
        rootElement.querySelector('input[name="recipient_name"]').addEventListener('input', function (e) {
            recipientName = e.target.value;
            rootElement.querySelector('.recipientName').textContent = recipientName;
        });
        rootElement.querySelector('input[name="sender_name"]').addEventListener('input', function (e) {
            senderName = e.target.value;
            rootElement.querySelector('.senderName').textContent = senderName;
        });
        rootElement.querySelector('textarea[name="note"]').addEventListener('input', function (e) {
            rootElement.querySelector('.note').textContent = `"${e.target.value}"`;
        })

        /***********
         SUBMIT FORM
         ***********/
        document.querySelector('.sendHintModalForm').addEventListener('submit', async function (e) {
            e.preventDefault();

            // add loading
            rootElement.querySelector('.sendHintModalFormSubmit').classList.add('loading');

            // Send form data to API
            const formData = new FormData(this);

            // add URL = current page URL
            formData.append('url', window.location.href);

            // add product title
            formData.append('product_title', product.title);

            let payload = Object.fromEntries(formData);

            const response = await fetch('https://api.audryrosejewelry.com/public/send-a-hint.php', {
                method: 'POST',
                body: JSON.stringify(payload),
            })
                .then(response => response.json())

            rootElement.querySelector('.sendHintModalFormSubmit').classList.remove('loading');

            // error
            if (response.error) {
                rootElement.querySelector('.sendHintModalFormError').textContent = `There was an error with your request: ` + response.error;
                return;
            }

            // success - hide form, show success message
            rootElement.querySelector('.sendHintModalForm').classList.remove('active');
            rootElement.querySelector('.sendHintModalSuccess').classList.add('active');
        })


        /***********
         SEND A HINT MODAL
         ***********/

        // open sendHintModal
        document.querySelectorAll('.openHint').forEach(function (element) {
            element.addEventListener('click', function () {
                document.querySelector(".sendHintModal").showModal();
                document.querySelector("body").classList.add("noScroll");
            });
        })

        // close sendHintModal
        function closeSendHint() {
            document.querySelector(".sendHintModal").close();
            document.querySelector("body").classList.remove("noScroll");
        }

        // close sendHintModal event listener
        document.querySelectorAll(".sendHintModalClose").forEach(function (element) {
            element.addEventListener("click", closeSendHint);
        });

        document.querySelector(".sendHintModal").addEventListener("click", function (e) {
            if (e.target === this) {
                closeSendHint();
            }
        })

        // close event
        document.querySelector(".sendHintModal").addEventListener("close", function () {
            document.querySelector("body").classList.remove("noScroll");
        });

    }


    // list of attributes to monitor
    static get observedAttributes() {
        return ["data-variant-id"];
    }

    // when an observed attribute changes, re-run the connectedCallback
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue) {
            this.connectedCallback();
        }
    }
}

// define the element
customElements.define("send-a-hint", SendAHint);